<template>
  <div>
    <el-tabs v-model="activeTab" tab-position="top">
      <el-tab-pane label="C/C++语言" name="tab1">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="dmsl">
                <div class="butt_div">
                  <div>
                    <span class="shili">示例:</span
                    ><el-button  >直接下载</el-button
                    ><el-button @click="openWeChatChat()">联系客服</el-button>
                  </div>
                </div>
                <div class="shilidiv">实例：</div>
                <pre class="json-code">

<span class="lv">// demo.cpp : 定义控制台应用程序的入口点。</span>
<span class="lv">//</span>

#<span class="hong_">include</span> <span class="">"stdafx.h"</span>
#<span class="hong_">include</span> <span class="">"curl/curl.h"</span>
#pragma comment(lib, <span class=""></span>"libcurl.lib")
<span class="lv">//curl 回调函数</span>
static size_t write_buff_data(char *buffer, size_t size, size_t nitems, void *outstream)
{<span class="lv">//把接收的数据拷贝到缓存中</span>
	memcpy(outstream, buffer, nitems*size);
	return nitems*size;
}
<span class="lv">/*</span>
<span class="lv">使用http代理</span>
<span class="lv">*/</span>
<span class="lv">int</span> GetUrlHTTP(char *url, char *buff)
{
	CURL *curl;
	CURLcode res;
	curl = curl_easy_init();
	<span class="hong_">if</span> (curl)
	{
		curl_easy_setopt(curl, CURLOPT_PROXY,<span class="lan_"></span>"http://域名:端口");<span class="lv">//设置http代理地址</span>
		curl_easy_setopt(curl, CURLOPT_PROXYUSERPWD, <span class="lan_"></span>"用户名:密码");<span class="lv">//代理用户名密码，以":"风格用户名以及密码</span>
		curl_easy_setopt(curl, CURLOPT_WRITEDATA, (void*)buff);<span class="lan_">//设置读写缓存</span>
		curl_easy_setopt(curl, CURLOPT_WRITEFUNCTION, write_buff_data);<span class="lan_">//设置回调函数</span>
		curl_easy_setopt(curl, CURLOPT_URL, url);<span class="lv">//设置url地址</span>
		curl_easy_setopt(curl, CURLOPT_LOW_SPEED_TIME, 10L);<span class="lv">//设置一个长整形数，控制多少秒传送CURLOPT_LOW_SPEED_LIMIT规定的字节数</span>
		curl_easy_setopt(curl, CURLOPT_LOW_SPEED_LIMIT, 50L);<span class="lv">//设置一个长整形数,控制传送多少字节</span>
		curl_easy_setopt(curl, CURLOPT_MAX_RECV_SPEED_LARGE, 2000000L);<span class="lv">//下载最高速度</span>

		res = curl_easy_perform(curl);
		curl_easy_cleanup(curl);
		<span class="hong_">if</span> (res == CURLE_OK){
			return res;
		}<span class="hong_">else</span> {
			printf(<span class="lan_"></span>"错误代码:%d\n", res);
			MessageBox(NULL, TEXT(<span class="lan_">"获取IP错误"</span>), TEXT(<span class="lan_">"助手"</span>), MB_ICONINFORMATION | MB_YESNO);
		}
	}
	return res;
}
/*
使用socks5代理
*/
<span class="hong_">int</span> GetUrlSocks5(char *url, char *buff)
{
	CURL *curl;
	CURLcode res;
	curl = curl_easy_init();
	<span class="hong_">if</span> (curl)
	{
		curl_easy_setopt(curl, CURLOPT_PROXY, <span class="lan_">"socks5://域名:端口"</span>);//设置socks5代理地址
		curl_easy_setopt(curl, CURLOPT_PROXYUSERPWD, <span class="lan_">"用户名:密码"</span>);//代理用户名密码，以":"风格用户名以及密码
		curl_easy_setopt(curl, CURLOPT_WRITEDATA, (void*)buff);//设置读写缓存
		curl_easy_setopt(curl, CURLOPT_WRITEFUNCTION, write_buff_data);//设置回调函数
		curl_easy_setopt(curl, CURLOPT_URL, url);//设置url地址
		curl_easy_setopt(curl, CURLOPT_LOW_SPEED_TIME, 10L);//设置一个长整形数，控制多少秒传送CURLOPT_LOW_SPEED_LIMIT规定的字节数
		curl_easy_setopt(curl, CURLOPT_LOW_SPEED_LIMIT, 50L);//设置一个长整形数,控制传送多少字节;
		curl_easy_setopt(curl, CURLOPT_MAX_RECV_SPEED_LARGE, 2000000L);/*下载最高速度*/
		res = curl_easy_perform(curl);
		curl_easy_cleanup(curl);
		<span class="hong_">if</span> (res == CURLE_OK) {
			return res;
		}
		<span class="hong_">else</span> {
			printf("错误代码:%d\n", res);
			MessageBox(NULL, TEXT(<span class="lan_">"获取IP错误"</span>), TEXT(<span class="lan_">"助手"</span>), MB_ICONINFORMATION | MB_YESNO);
		}
	}
	return res;
}
/*
不使用代理
*/
<span class="hong_">int</span> GetUrl(char *url, char *buff)
{
	CURL *curl;
	CURLcode res;
	//使用的curl库 初始化curl库
	curl = curl_easy_init();
	<span class="hong_">if</span> (curl)
	{
		curl_easy_setopt(curl, CURLOPT_WRITEDATA, (void*)buff);//设置读写缓存
		curl_easy_setopt(curl, CURLOPT_WRITEFUNCTION, write_buff_data);//设置回调函数
		curl_easy_setopt(curl, CURLOPT_URL, url);//设置url地址
		curl_easy_setopt(curl, CURLOPT_LOW_SPEED_TIME, 10L);//设置一个长整形数，控制多少秒传送CURLOPT_LOW_SPEED_LIMIT规定的字节数
		curl_easy_setopt(curl, CURLOPT_LOW_SPEED_LIMIT, 50L);//设置一个长整形数,控制传送多少字节
		curl_easy_setopt(curl, CURLOPT_MAX_RECV_SPEED_LARGE, 2000000L);/*下载最高速度*/
		res = curl_easy_perform(curl);
		curl_easy_cleanup(curl);
		<span class="hong_">if</span> (res == CURLE_OK)
		{
			return res;
		}
		<span class="hong_">else</span> {
			printf("错误代码:%d\n", res);
			MessageBox(NULL, TEXT(<span class="lan_">"获取IP错误"</span>), TEXT(<span class="lan_">"助手"</span>), MB_ICONINFORMATION | MB_YESNO);
		}
	}
	return res;
}
<span class="hong_">int</span> main()
{
	<span class="hong_">char</span> *buff=(<span class="hong_">char</span>*)malloc(1024*1024);
	memset(buff, 0, 1024 * 1024);
	//不使用http代理
	GetUrl(<span class="lan_">"http://apiupss.ppfly.top/index.html"</span>, buff);
	printf("不使用代理：%s\n", buff);
	//使用http代理
	memset(buff, 0, 1024 * 1024);
	GetUrlHTTP(<span class="lan_">"http://apiupss.ppfly.top/index.html"</span>, buff);
	printf("http结果：%s\n", buff);
	//使用socks5代理
	memset(buff, 0,1024 * 1024);
	GetUrlSocks5(<span class="lan_">"http://apiupss.ppfly.top/index.html"</span>, buff);
	printf("socks5结果：%s\n", buff);

	Sleep(1000 * 1000);
	free(buff);
    return 0;
}


                                </pre>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="GO语言" name="tab2">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="dmsl">
                <div class="butt_div">
                  <div>
                    <span class="shili">示例:</span
                    ><el-button  >直接下载</el-button
                    ><el-button @click="openWeChatChat()">联系客服</el-button>
                  </div>
                </div>
                <div class="shilidiv">实例：</div>
                <pre class="json-code">

<span class="hong_">package</span> main

<span class="hong_">import</span> (
	<span class="lan_">"context"</span>
	<span class="lan_">"fmt"</span>
	<span class="lan_">"golang.org/x/net/proxy"</span>
	<span class="lan_">"io/ioutil"</span>
	<span class="lan_">"net"</span>
	<span class="lan_">"net/http"</span>
	<span class="lan_">"net/url"</span>
	<span class="lan_">"strings"</span>
	<span class="lan_">"time"</span>
)

<span class="hong_">var</span> testApi = <span class="lan_">"http://apiupss.ppfly.top"</span>

<span class="hong_">func</span> main() {
	getMyIp()
	<span class="lv">//账密</span>
	go httpProxy(<span class="lan_">"ip:port"</span>, <span class="lan_">"账户"</span>, <span class="lan_">"密码"</span>)
	go Socks5Proxy(<span class="lan_">"ip:port"</span>, <span class="lan_">"账户"</span>, <span class="lan_">"密码"</span>)

	time.Sleep(time.Minute)
}

<span class="hong_">func</span> getMyIp() {
	rsp, err := http.Get(<span class="lan_">"http://apiupss.ppfly.top"</span>)
	<span class="hong_">if</span> err != <span class="hong_">nil</span> {
		fmt.Println(<span class="lan_">"获取本机ip失败"</span>, err.Error())
		<span class="hong_">return</span>
	}
	<span class="hong_">defer</span> rsp.Body.Close()
	body, err := ioutil.ReadAll(rsp.Body)
	<span class="hong_">if</span> err != <span class="hong_">nil</span> {
		fmt.Println(err.Error())
		return
	}
	fmt.Println(time.Now().Format(<span class="lan_">"2006-01-02 15:04:05 07"</span>), <span class="lan_">"本机ip:"</span>, <span class="hong_">string</span>(body))

}

<span class="lv">//http代理</span>
<span class="hong_">func</span> httpProxy(proxyUrl, user, pass string) {
	<span class="hong_">defer</span> <span class="hong_">func</span>() {
		<span class="hong_">if</span> err := <span class="hong_">recover</span>(); err != <span class="hong_">nil</span> {
			fmt.Println(time.Now().Format(<span class="lan_">"2006-01-02 15:04:05 07"</span>), <span class="lan_">"http"</span>, <span class="lan_">"返回信息:"</span>, err)
		}
	}()
	urli := url.URL{}

	<span class="hong_">if</span> !strings.Contains(proxyUrl, <span class="lan_">"http"</span>) {
		proxyUrl = fmt.Sprintf(<span class="lan_">"http://%s"</span>, proxyUrl)
	}

	urlProxy, _ := urli.Parse(proxyUrl)
	<span class="hong_">if</span> user != <span class="lan_">""</span> && pass != <span class="lan_">""</span> {
		urlProxy.User = url.UserPassword(user, pass)
	}

	client := &http.Client{
		Transport: &http.Transport{
			Proxy: http.ProxyURL(urlProxy),
		},
	}
	rqt, err := http.NewRequest(<span class="lan_">"GET"</span>, testApi, <span class="hong_">nil</span>)
	<span class="hong_">if</span> err != <span class="hong_">nil</span> {
		<span class="hong_">panic</span>(err)
		<span class="hong_">return</span>
	}
	response, err := client.Do(rqt)
	<span class="hong_">if</span> err != <span class="hong_">nil</span> {
		<span class="hong_">panic</span>(err)
		<span class="hong_">return</span>
	}

	<span class="hong_">defer</span> response.Body.Close()
	body, _ := ioutil.ReadAll(response.Body)
	fmt.Println(time.Now().Format("2006-01-02 15:04:05 07"), proxyUrl, "【http success】", "返回信息:", response.Status, string(body))

	<span class="hong_">return</span>
}

<span class="lv">//socks5代理</span>
<span class="hong_">func</span> Socks5Proxy(proxyUrl, user, pass <span class="hong_">string</span>) {

	<span class="hong_">defer</span> func() {
		<span class="hong_">if</span> err := recover(); err != nil {
			fmt.Println(time.Now().Format(<span class="lan_">"2006-01-02 15:04:05 07"</span>), proxyUrl, <span class="lan_">"返回信息:"</span>, err)
		}
	}()

	<span class="hong_">var</span> userAuth proxy.Auth
	<span class="hong_">if</span> user != <span class="lan_">""</span> && pass != <span class="lan_">""</span> {
		userAuth.User = user
		userAuth.Password = pass
	}
	dialer, err := proxy.SOCKS5("tcp", proxyUrl, &userAuth, proxy.Direct)
	<span class="hong_">if</span> err != <span class="hong_"></span>nil {
		<span class="hong_">panic</span>(err)
	}
	httpClient := &http.Client{
		Transport: &http.Transport{
			DialContext: <span class="hong_">func</span>(ctx context.Context, network, addr string) (conn net.Conn, err <span class="hong_"></span>error) {
				<span class="hong_">return</span> dialer.Dial(network, addr)
			},
		},
		Timeout: time.Second * <span class="lan_">10</span>,
	}

	<span class="lv">//请求网络</span>
	<span class="hong_">if</span> resp, err := httpClient.Get(testApi); err != <span class="hong_"></span>nil {
		<span class="hong_">panic</span>(err)
	} <span class="hong_">else</span> {
		<span class="hong_">defer</span> resp.Body.Close()
		body, _ := ioutil.ReadAll(resp.Body)
		fmt.Println(time.Now().Format(<span class="lan_">"2006-01-02 15:04:05 07"</span>), proxyUrl, <span class="lan_">"【socks5 success】"</span>, <span class="lan_">"返回信息:"</span>, string(body))
	}
}




                                </pre>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Node.js语言" name="tab3">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="dmsl">
                <div class="butt_div">
                  <div>
                    <span class="shili">示例:</span
                    ><el-button  >直接下载</el-button
                    ><el-button @click="openWeChatChat()">联系客服</el-button>
                  </div>
                </div>
                <div class="shilidiv">实例：</div>
                <pre class="json-code">

#!<span class="lan_">/usr/</span>bin/env node
require(<span class="lan_">'request-promise'</span>)({
    url: <span class="lan_">'http://apiupss.ppfly.top'</span>,
    proxy: <span class="lan_">'http://apiupss.ppfly.top'</span>,
    })
.then(<span class="hong_">function</span>(data){ <span class="hong_">console.log(data)</span>; },
<span class="hong_">function</span>(err){ <span class="hong_">console.log(data)</span>console.log(data); });


                                </pre>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Php语言" name="tab4">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="dmsl">
                <div class="butt_div">
                  <div>
                    <span class="shili">示例:</span
                    ><el-button  >直接下载</el-button
                    ><el-button @click="openWeChatChat()">联系客服</el-button>
                  </div>
                </div>
                <div class="shilidiv">实例：</div>
                <pre class="json-code">

    ?php
	<span class='lv'>// 要访问的目标页面</span>
	$targetUrl = <span class='lan_'>"http://baidu.com"</span>;
	<span class='lv'>// 代理服务器</span>
	$proxyServer = <span class='lan_'>"http://apiupss.ppfly.top"</span>;
	$proxyUserPwd = <span class='lan_'>"{{usertext}}:{{psswdtext}}"</span>;


	<span class='lv'>// 隧道身份信息</span>
	$ch = curl_init();
	curl_setopt($ch, CURLOPT_URL, $targetUrl);
	curl_setopt($ch, CURLOPT_HTTPPROXYTUNNEL, false);
	curl_setopt($ch, CURLOPT_SSL_VERIFYPEER, false);

	<span class='lv'>// 设置代理服务器</span>
	curl_setopt($ch, CURLOPT_PROXYTYPE, 0); <span class=''>//http</span>
	<span class='lv'>// curl_setopt($ch, CURLOPT_PROXYTYPE, 5); //sock5</span>
	curl_setopt($ch, CURLOPT_PROXY, $proxyServer);

	<span class='lv'>// 设置隧道验证信息</span>
	curl_setopt($ch, CURLOPT_PROXYAUTH, CURLAUTH_BASIC);
	curl_setopt($ch, CURLOPT_USERAGENT, <span class='lan_'>"Mozilla/4.0 (compatible; MSIE 6.0; Windows NT 5.1; SV1; .NET CLR 2.0.50727;)"</span>);
	curl_setopt($ch, CURLOPT_CONNECTTIMEOUT, 3);
	curl_setopt($ch, CURLOPT_TIMEOUT, 5);
	curl_setopt($ch, CURLOPT_HEADER, true);
	curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
	curl_setopt($ch, CURLOPT_PROXYUSERPWD, $proxyUserPwd);
	$result = curl_exec($ch);
	$err = curl_error($ch);

	curl_close($ch);

	var_dump($err);
	var_dump($result);


                                </pre>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="JAVA语言" name="tab5">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="dmsl">
                <div class="butt_div">
                  <div>
                    <span class="shili">示例:</span
                    ><el-button  >直接下载</el-button
                    ><el-button @click="openWeChatChat()">联系客服</el-button>
                  </div>
                </div>
                <div class="shilidiv">实例：</div>
                <pre class="json-code">

package demo;

<span class="hong_">import</span> okhttp3.Credentials;
<span class="hong_">import</span> okhttp3.OkHttpClient;
<span class="hong_">import</span> okhttp3.Request;

<span class="hong_">import</span> java.io.IOException;
<span class="hong_">import</span> java.net.InetSocketAddress;
<span class="hong_">import</span> java.net.PasswordAuthentication;
<span class="hong_">import</span> java.net.Proxy;

<span class="lv">/**</span>
<span class="lv"> * compile 'com.squareup.okhttp3:okhttp:3.10.0'</span>
<span class="lv"> */</span>
<span class="lv">class</span> <span class="hong_">AutProxyJava</span> {
    public <span class="hong_">static</span> <span class="zi">void</span> main(<span class="cheng">String</span>[] args) throws IOException {
        testWithOkHttp();

        testSocks5WithOkHttp();
    }

    public <span class="hong_">static</span> <span class="zi">void</span> testWithOkHttp() throws IOException {
        <span class="hong_">String</span> url = <span class="lan_">"http://apiupss.ppfly.top"</span>;
        <span class="hong_">Proxy</span> proxy = <span class="hong_">new</span> Proxy(Proxy.Type.HTTP, new InetSocketAddress(<span class="lan_">"代理地址"</span>, <span class="lan_">8080</span>));
        OkHttpClient client = <span class="">new</span> OkHttpClient().newBuilder().proxy(proxy).proxyAuthenticator((route, response) -> {
            <span class="hong_">String</span> credential = Credentials.basic(<span class="lan_">"账户"</span>, <span class="lan_">"密码"</span>);
            <span class="hong_">return</span> response.request().newBuilder()
                    .header(<span class="lan_">"Proxy-Authorization"</span>, credential)
                    .build();
        }).build();


        Request request = <span class="hong_">new</span> Request.Builder().url(url).build();
        okhttp3.Response response = client.newCall(request).execute();
        String responseString = response.body().string();
        System.out.println(responseString);
    }

    public static <span class="zi">void</span> testSocks5WithOkHttp() throws IOException {
        String url = <span class="lan_">"http://apiupss.ppfly.top"</span>;
        Proxy proxy = <span class="hong_">new</span> Proxy(Proxy.Type.SOCKS, <span class="hong_">new</span> InetSocketAddress(<span class="lan_">"代理地址"</span>, <span class="lan_">8080</span>));
        java.net.Authenticator.setDefault(<span class="hong_">new</span> java.net.Authenticator() {
            private PasswordAuthentication authentication =
            <span class="hong_">new</span> PasswordAuthentication(<span class="lan_">"账户"</span>, <span class="lan_">"密码"</span>.toCharArray());

            @Override
            protected PasswordAuthentication getPasswordAuthentication() {
                <span class="hong_">return</span> authentication;
            }
        });
        OkHttpClient client = <span class="hong_">new</span> OkHttpClient().newBuilder().proxy(proxy).build();
        Request request = <span class="hong_">new</span> Request.Builder().url(url).build();
        okhttp3.Response response = client.newCall(request).execute();
        String responseString = response.body().string();
        System.out.println(responseString);
    }
}




                                </pre>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="python语言" name="tab6">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="dmsl">
                <div class="butt_div">
                  <div>
                    <span class="shili">示例:</span
                    ><el-button  >直接下载</el-button
                    ><el-button @click="openWeChatChat()">联系客服</el-button>
                  </div>
                </div>
                <div class="shilidiv">实例：</div>
                <pre class="json-code">


import _thread
import time

import requests

headers = {
    <span class="lan_">
    "Accept": "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
    "User-Agent": "Mozilla/5.0 (iPhone; CPU iPhone OS 10_3_3 like Mac OS X) AppleWebKit/603.3.8 (KHTML, like Gecko) Mobile/14G60 MicroMessenger
    /6.5.19 NetType/4G Language/zh_TW",
    </span>
}

mainUrl = <span class="lan_">'http://apiupss.ppfly.top'</span>


def testUrl():
    # 账密
    entry = <span class="lan_">'http://{}:{}@ip:port'</span>.format(<span class="lan_">"账户"</span>, <span class="lan_">"密码"</span>)

    <span class="hong_">proxy</span> = {
        <span class="lan_">'http'</span>: entry,
        <span class="lan_">'https'</span>: entry,
    }
    <span class="hong_">try</span>:
        res = requests.get(mainUrl, <span class="hong_">headers</span>=headers, <span class="hong_">proxies</span>=proxy, timeout=10)
        <span class="hong_">print</span>(res.status_code, res.text)
    except Exception as e:
        <span class="hong_">print</span>(<span class="lan_">"访问失败"</span>, e)
        pass


<span class="hong_">for port in</span> range(0, 10):
    _thread.start_new_thread(testUrl, ())
    time.sleep(0.1)

time.sleep(10)

                                </pre>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="python-selenium语言" name="tab7">
        <div class="main-content_pane_div">
          <div class="content_pane_div_let">
            <div class="content_pane_div_let_div">
              <div class="dmsl">
                <div class="butt_div">
                  <div>
                    <span class="shili">示例:</span
                    ><el-button  >直接下载</el-button
                    ><el-button @click="openWeChatChat()">联系客服</el-button>
                  </div>
                </div>
                <div class="shilidiv">实例：</div>
                <pre class="json-code">

<span class="lan_">
'''
注意：本方法需要安装seleniumwire库  pip install selenium-wire
其他情况下 可能需要配合selenium的webdriver使用  即selenium和seleniumwire都要导入
使用seleniumwire库的目的就是减少代码量和无意义的插件使用，方便快捷
'''
</span>


<span class="hong_">from</span> seleniumwire <span class="hong_">import</span> webdriver

<span class="lv">
# selenium-wire 代理设置
# username 用户名
# password 密码
# host 域名
# port 端口
</span>

seleniumwire_options = {
    <span class="lan_">'proxy'</span>: {
        <span class="lan_">'http': 'http://myusername:password@host:port'</span>,
        <span class="lan_">'https': 'http://myusername:password@host:port'</span>,
        'no_proxy': 'localhost,127.0.0.1'
    }
}

<span class="lv"># other Chrome options</span>
chrome_options = webdriver.ChromeOptions()
<span class="lv"># 设置无头</span>
chrome_options.add_argument(<span class="lan_">'--headless'</span>)
<span class="lv"># 忽视ssl报错</span>
chrome_options.add_argument(<span class="lan_">'--ignore-ssl-errors'</span>)
driver = webdriver.Chrome(<span class="lan_">'chromedriver'</span>, options=chrome_options, seleniumwire_options=seleniumwire_options)
driver.get(<span class="lan_">'http://apiupss.ppfly.top'</span>)

                                </pre>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      usertext: "user",
      psswdtext: "psswd",
      shifoudiqu: false,
      maindiv: "",
      activeTab: "tab1",
      isActive: false,
      isActiveB: false,
      form: {
        package: "",
        quantity: "",
        dataFormat: "",
        country: "",
        proxyAgreement: "",
        separator: "",
      },
      quanqiu: [
        { name: "全球混播" },
        { name: "美国" },
        { name: "韩国" },
        { name: "日本" },
        { name: "中国香港" },
        { name: "菲律宾" },
        { name: "越南" },
        { name: "印度" },
        { name: "缅甸" },
        { name: "泰国" },
        { name: "马来西亚" },
        { name: "中国台湾" },
        { name: "印度尼西亚" },
        { name: "孟加拉国" },
        { name: "巴基斯坦" },
        { name: "巴林" },
        { name: "科威特" },
        { name: "阿曼" },
        { name: "卡塔尔" },
        { name: "沙特阿拉伯" },
        { name: "阿联酋" },
        { name: "伊拉克" },
        { name: "以色列" },
        { name: "约旦" },
        { name: "阿塞拜疆" },
        { name: "伊朗" },
        { name: "土耳其" },
        { name: "哈萨克斯坦" },
        { name: "乌兹别克斯坦" },
        { name: "新加坡" },
        { name: "中国澳门" },
        { name: "文莱" },
        { name: "柬埔寨" },
        { name: "老挝" },
        { name: "法国" },
        { name: "英国" },
        { name: "德国" },
        { name: "卢森堡" },
        { name: "俄罗斯" },
        { name: "白俄罗斯" },
        { name: "比利时" },
        { name: "奥地利" },
        { name: "西班牙" },
        { name: "爱尔兰" },
        { name: "芬兰" },
        { name: "葡萄牙" },
        { name: "拉脱维亚" },
        { name: "波兰" },
        { name: "立陶宛" },
        { name: "匈牙利" },
        { name: "荷兰" },
        { name: "瑞士" },
        { name: "捷克共和国" },
        { name: "挪威" },
        { name: "希腊" },
        { name: "乌克兰" },
        { name: "丹麦" },
        { name: "罗马尼亚" },
        { name: "塞尔维亚" },
        { name: "加拿大" },
        { name: "牙买加" },
        { name: "墨西哥" },
        { name: "巴拿马" },
        { name: "哥斯达黎加" },
        { name: "危地马拉" },
        { name: "洪都拉斯" },
        { name: "波多黎各" },
        { name: "阿根廷" },
        { name: "巴西" },
        { name: "哥伦比亚" },
        { name: "智利" },
        { name: "委内瑞拉" },
        { name: "秘鲁" },
        { name: "玻利维亚" },
        { name: "厄瓜多尔" },
        { name: "圭亚那" },
        { name: "巴拉圭" },
        { name: "乌拉圭" },
        { name: "新西兰" },
        { name: "澳大利亚" },
        { name: "马达加斯加" },
        { name: "莫桑比克" },
        { name: "南非" },
        { name: "埃塞俄比亚" },
        { name: "肯尼亚" },
        { name: "加纳" },
        { name: "阿尔及利亚" },
        { name: "埃及" },
        { name: "摩洛哥" },
        { name: "突尼斯" },
        { name: "不丹" },
        { name: "马尔代夫" },
        { name: "尼泊尔" },
        { name: "斯里兰卡" },
        { name: "也门" },
        { name: "塞浦路斯" },
        { name: "黎巴嫩" },
        { name: "巴勒斯坦" },
        { name: "叙利亚" },
        { name: "阿富汗" },
        { name: "亚美尼亚" },
        { name: "土库曼斯坦" },
        { name: "格鲁吉亚" },
        { name: "东帝汶" },
        { name: "蒙古国" },
        { name: "梵蒂冈" },
        { name: "摩尔多瓦" },
        { name: "摩纳哥" },
        { name: "冰岛" },
        { name: "马耳他" },
        { name: "爱沙尼亚" },
        { name: "克罗地亚" },
        { name: "阿尔巴尼亚" },
        { name: "波黑" },
        { name: "保加利亚" },
        { name: "黑山" },
        { name: "马其顿" },
        { name: "斯洛文尼亚" },
        { name: "斯洛伐克" },
        { name: "科索沃" },
        { name: "安道尔公国" },
        { name: "泽西岛" },
        { name: "马恩岛" },
        { name: "根西岛" },
        { name: "列支敦士登" },
        { name: "欧洲" },
        { name: "直布罗陀" },
        { name: "格陵兰" },
        { name: "圣卢西亚" },
        { name: "阿鲁巴" },
        { name: "库拉索" },
        { name: "多米尼加" },
        { name: "瓜德罗普" },
        { name: "萨尔瓦多" },
        { name: "特立尼达和多巴哥" },
        { name: "巴哈马" },
        { name: "多米尼加共和国" },
        { name: "伯利兹" },
        { name: "巴巴多斯" },
        { name: "荷属圣马丁" },
        { name: "圣文森特岛" },
        { name: "安提瓜和巴布达" },
        { name: "尼加拉瓜" },
        { name: "海地共和国" },
        { name: "开曼群岛" },
        { name: "法属圣马丁" },
        { name: "美属维尔京群岛" },
        { name: "马提尼克" },
        { name: "英属维尔京群岛" },
        { name: "圣基茨和尼维斯" },
        { name: "百慕大" },
        { name: "苏里南" },
        { name: "法属圭亚那" },
        { name: "帕劳" },
        { name: "斐济群岛" },
        { name: "巴布亚新几内亚" },
        { name: "新喀里多尼亚" },
        { name: "法属波利尼西亚" },
        { name: "关岛" },
        { name: "托克劳" },
        { name: "密克罗尼西亚联邦" },
        { name: "所罗门群岛" },
        { name: "瓦努阿图" },
        { name: "美属萨摩亚" },
        { name: "安哥拉" },
        { name: "布基纳法索" },
        { name: "贝宁" },
        { name: "博茨瓦纳" },
        { name: "刚果(布)" },
        { name: "科特迪瓦" },
        { name: "加蓬" },
        { name: "利比亚" },
        { name: "马里" },
        { name: "毛里求斯" },
        { name: "纳米比亚" },
        { name: "留尼汪" },
        { name: "卢旺达" },
        { name: "苏丹" },
        { name: "塞内加尔" },
        { name: "南苏丹" },
        { name: "多哥" },
        { name: "乌干达" },
        { name: "津巴布韦" },
        { name: "坦桑尼亚" },
        { name: "毛里塔尼亚" },
        { name: "索马里" },
        { name: "冈比亚" },
        { name: "格林纳达" },
        { name: "刚果金" },
        { name: "喀麦隆" },
        { name: "赞比亚共和国" },
        { name: "圣多美和普林西比" },
        { name: "佛得角共和国" },
        { name: "赤道几内亚" },
        { name: "马拉维" },
        { name: "吉布提国家" },
        { name: "几内亚" },
        { name: "利比里亚" },
        { name: "尼日尔共和国" },
        { name: "几内亚比绍" },
        { name: "塞拉利昂" },
        { name: "莱索托" },
        { name: "斯威士兰" },
        { name: "科摩罗" },
        { name: "塞舌尔共和国" },
        { name: "马约特" },
      ],
    };
  },
  created() {
    // 在组件创建时获取路由参数
    this.userId = this.$route.params.id;
  },
  components: {},
  mounted() {},
  methods: {
    openWeChatChat() {
    },
    onclick(name) {
      console.log();
      this.maindiv = name;
    },
    toggleBorder() {
      this.isActive = true; // 切换边框状态
      this.isActiveB = false;
    },
    toggleBorderB() {
      this.isActiveB = true; // 切换边框状态
      this.isActive = false;
    },
    generateLink() {
      // 处理生成链接的逻辑
      console.log("生成链接:", this.form);
    },
  },
};
</script>
<style>
.getapi {
}

.getapi_body {
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.el-menu-item {
  border-radius: 15px;
  text-align: left;
}

.title_img {
  text-align: left;
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
  /* overflow-y: scroll; */
  height: 800px;
}

.content_pane_div_let {
}
.main-content_pane_div {
  display: flex;
  justify-content: space-between;
}

.content_pane_div_let_div {
  overflow-y: scroll;
  height: 730px;
}

.content_pane_div_let_div_div {
  display: flex;
  justify-content: space-around;
  width: 900px;
  padding: 10px;
}

.content_pane_div_let_div_divs {
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border-radius: 5px;
  width: 400px;
}

.content_pane_div_let_div_divsB {
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border-radius: 5px;
  width: 1400px;
}

.active-border {
  box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  /* 点击后添加的边框样式 */
}

.content_pane_div_let_div_divs:nth-child(1) {
  margin-right: 10px;
}

.content_pane_div_let_div_divs > div:nth-child(1) {
}

.content_pane_div_let_div_divs > div:nth-child(2) {
}

.content_pane_div_let_div_divs > div:nth-child(3) {
}

.zhed_cls {
  text-align: left;
  display: flex;
  align-items: center;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #18181b;
}

.div_zhed_cls_text {
  margin-top: 10px;
}

.zhed_cls_text {
  font-size: 14px;
  color: #737791;
  display: flex;
  justify-content: space-between;
}

.zhed_cls_text > div {
  font-size: 16px;
  color: #000;
  line-height: 22px;
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.div_xiala {
  background-color: #edf3fc;
  /* 表单背景色 */
  padding: 20px;
  /* 内边距 */
  border-radius: 5px;
  /* 圆角 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

.but_sclj {
  width: 207px;
  height: 38px;
  background: #1a73e8;
  box-shadow: 0 11px 10px 0 rgba(29, 104, 250, 0.13);
  border-radius: 6px;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  color: #edf3fc;
  cursor: pointer;
  margin-right: 150px;
  margin-top: 50px;
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.jkcszj {
  background-color: #edf3fc;
  /* 接口参数注解背景色 */
  padding: 20px;
  /* 内边距 */
  border-radius: 5px;
  /* 圆角 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

.jkcszj h2 {
  margin-bottom: 20px;
  /* 标题下边距 */
}

.no-border-table {
  width: 100%;
  border-collapse: collapse;
  /* 合并边框 */
}

.no-border-table th,
.no-border-table td {
  border: none;
  /* 无边框 */
  padding: 10px;
  /* 单元格内边距 */
  text-align: left;
  /* 左对齐 */
}

.no-border-table th {
  background-color: #f0f0f0;
  /* 表头背景色 */
}

.H2_text {
  font-family: SourceHanSansCN-Bold;
  font-size: 16px;
  color: #18181b;
  display: flex;
  align-items: center;
  margin-left: -25px;
}

.H3_text {
  font-family: SourceHanSansCN-Bold;
  font-size: 13px;
  color: #505053;
  display: flex;
  align-items: center;
}

.top_name {
  font-size: 16px;
  font-weight: 700;
  background: #f0f9ff;
  border-radius: 7px;
  height: 48px;
  border-bottom: none;
}

.top_name_th {
  font-size: 13px;
}

.top_text {
  font-size: 14px;
  height: 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  font-size: 14px;
  font-weight: 400;
  color: #444a6d;
  text-align: center;
}

.json-code {
  text-align: left;
  /* 使文本左对齐 */
  background-color: #f8f8f8;
  /* 设置背景颜色 */
  /* 添加边框 */
  padding: 10px;
  /* 添加内边距 */
  overflow: auto;
  /* 处理溢出内容 */
  white-space: pre-wrap;
  /* 允许换行 */
  font-family: SimHei;
  /* 使用等宽字体 */
  font-size: 15px;
}

.lan_ {
  color: rgb(0, 0, 255);
}
.hong_ {
  color: #808;
}
.cheng {
  color: #f40;
}
.zi {
  color: #639;
}
.lv {
  color: #070;
}

.butt_div {
  display: flex;
  justify-content: left;
}

.shili {
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 16px;
  color: #18181b;
  line-height: 32px;
  margin-right: 40px;
}

.shilidiv {
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 16px;
  color: #18181b;
  line-height: 32px;
  margin-right: 40px;
  text-align: left;
}
</style>
